// Conversion tracking types and utilities

export interface Conversion {
  id: string;
  adId: string;
  advertiserId: string;
  userId: string; // User who converted
  conversionType: 'purchase' | 'signup' | 'download' | 'lead' | 'custom';
  conversionValue?: number; // Value in USD
  metadata?: Record<string, any>; // Custom data
  timestamp: any;
  sourceClick?: string; // Click ID that led to this conversion
}

export interface ConversionPixel {
  adId: string;
  conversionType: string;
  conversionValue?: number;
  metadata?: Record<string, any>;
}

// Conversion pixel for advertisers' own websites. Belivah appends a signed click ID
// (bvclid) to ad links; the pixel stores it first-party and reports conversions with it.
export const generateConversionPixel = (advertiserId: string, apiBase: string): string => {
  const endpoint = `${apiBase.replace(/\/$/, '')}/px/c.gif`;
  return `<!-- Belivah Conversion Pixel: add to every page of your website -->
<script>
(function (w, d) {
  var K = 'belivah_clid', ADV = '${advertiserId}', EP = '${endpoint}';
  try {
    var m = /[?&]bvclid=([^&#]+)/.exec(w.location.search);
    if (m) {
      var v = decodeURIComponent(m[1]);
      w.localStorage.setItem(K, v);
      d.cookie = K + '=' + encodeURIComponent(v) + ';max-age=2592000;path=/;SameSite=Lax';
    }
  } catch (e) {}
  function clid() {
    try {
      var c = d.cookie.match(/(?:^|; )belivah_clid=([^;]+)/);
      return w.localStorage.getItem(K) || (c ? decodeURIComponent(c[1]) : null);
    } catch (e) { return null; }
  }
  w.BelivahConversion = {
    track: function (type, value, meta) {
      var c = clid();
      if (!c) return false;
      var img = new Image(1, 1);
      img.src = EP + '?clid=' + encodeURIComponent(c) + '&adv=' + encodeURIComponent(ADV) +
        '&type=' + encodeURIComponent(type || 'custom') + '&value=' + (Number(value) || 0) +
        '&m=' + encodeURIComponent(JSON.stringify(meta || {}).slice(0, 900)) + '&r=' + Date.now();
      return true;
    }
  };
})(window, document);
</script>`;
};

// Append the signed click ID so the advertiser's pixel can attribute conversions.
export const withClickId = (url: string, clickId?: string | null): string => {
  if (!clickId) return url;
  try {
    const u = new URL(url);
    u.searchParams.set('bvclid', clickId);
    return u.toString();
  } catch {
    return url;
  }
};
